import { render, staticRenderFns } from "./SatisfactionQuestionStar.vue?vue&type=template&id=0c898155&scoped=true&"
import script from "./SatisfactionQuestionStar.vue?vue&type=script&lang=js&"
export * from "./SatisfactionQuestionStar.vue?vue&type=script&lang=js&"
import style0 from "./SatisfactionQuestionStar.vue?vue&type=style&index=0&id=0c898155&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c898155",
  null
  
)

export default component.exports